module.exports = __webpack_public_path__ + "img/banner_dice_ff.915ee789.jpg";